module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rt-advance-table-item",
    style: (_vm.styles)
  }, [_c('div', {
    staticClass: "rt-advance-table-item-content"
  }, [_c('el-checkbox', _vm._b({}, 'el-checkbox', _vm.$attrs, false), [_vm._t("default")], 2)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-717c872b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/table/rtAdvanceTableItem.vue
// module id = 1531
// module chunks = 124